var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio-group',{attrs:{"size":"lg","options":_vm.displayOptions,"stacked":""}})}
var staticRenderFns = []

export { render, staticRenderFns }